import { extraescolares } from "./extraescolares";

const SITE_NAME = "DAC-PAC";
const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://campamentodacpac.es").replace(/\/$/, "");
const DEFAULT_IMAGE = `${SITE_URL}/logo_ac.png`;

function absoluteUrl(pathname = "/") {
  if (/^https?:\/\//i.test(pathname)) {
    return pathname;
  }

  return `${SITE_URL}${pathname.startsWith("/") ? pathname : `/${pathname}`}`;
}

function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "DAC-PAC",
    alternateName: "Campamento DAC-PAC",
    url: SITE_URL,
    email: "info@dacpac.es",
    logo: absoluteUrl("/logo_ac.png"),
    sameAs: ["https://www.instagram.com/dacpac.campamento"],
  };
}

function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "DAC-PAC",
    url: SITE_URL,
    inLanguage: "es-ES",
  };
}

const pageSeo = {
  "/": {
    title: "Campamento para altas capacidades en Espana | DAC-PAC",
    description:
      "Campamento de verano para altas capacidades en Espana, encuentro para adultos y extraescolares. DAC-PAC, de alta capacidad para alta capacidad.",
    keywords:
      "alta capacidad, altas capacidades, DAC-PAC, campamento altas capacidades, campamento alta capacidad, campamento DAC-PAC, campamento altas capacidades Espana",
    image: absoluteUrl("/images/campamento/guadarrama-hero.jpg"),
    schema: [
      organizationSchema,
      websiteSchema,
      () => ({
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "DAC-PAC",
        url: absoluteUrl("/"),
        description:
          "Experiencias presenciales para ninos, jovenes y adultos con altas capacidades en Espana.",
      }),
    ],
  },
  "/campamento-verano": {
    title: "Campamento de verano para altas capacidades | DAC-PAC",
    description:
      "Informacion del campamento de verano DAC-PAC para ninos y jovenes con altas capacidades. Proxima edicion en preparacion; solicita aviso cuando se publiquen fechas y condiciones.",
    keywords:
      "campamento altas capacidades, campamento alta capacidad, campamento DAC-PAC, campamento verano altas capacidades, aviso campamento altas capacidades",
    image: absoluteUrl("/images/campamento/entorno-natural.jpg"),
    schema: [
      organizationSchema,
      () => ({
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "Campamento de verano para altas capacidades",
        url: absoluteUrl("/campamento-verano"),
        description:
          "Campamento de verano DAC-PAC para ninos y jovenes con altas capacidades. Proxima edicion en preparacion.",
      }),
      () => ({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "Es necesario diagnostico oficial?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Si. Para participar en el Campamento de Verano es necesario contar con un diagnostico oficial de alta capacidad.",
            },
          },
          {
            "@type": "Question",
            name: "Pueden participar menores de 8 anos?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Por el momento el campamento esta disenado para participantes de 8 a 18 anos.",
            },
          },
        ],
      }),
    ],
  },
  "/campamento-verano/campamento-urbano": {
    title: "Campamento Urbano DAC-PAC 2027 | San Sebastian de los Reyes",
    description:
      "Informacion del Campamento Urbano DAC-PAC 2027 para ninos y ninas de 6 a 12 anos. Proxima edicion en preparacion; solicita aviso cuando se publiquen fechas y condiciones.",
    keywords:
      "campamento urbano altas capacidades, campamento urbano San Sebastian de los Reyes, campamento DAC-PAC 2027, aviso campamento urbano altas capacidades",
    image: DEFAULT_IMAGE, // TODO: sustituir por imagen destacada 1200x628 cuando este disponible.
    schema: [
      organizationSchema,
      () => ({
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "Campamento Urbano DAC-PAC 2027",
        url: absoluteUrl("/campamento-verano/campamento-urbano"),
        description:
          "Campamento urbano de verano para ninos, ninas y jovenes con altas capacidades en San Sebastian de los Reyes. Proxima edicion en preparacion.",
      }),
    ],
  },
  "/encuentro-adultos": {
    title: "Encuentro para adultos con altas capacidades | DAC-PAC",
    description:
      "Encuentro presencial para adultos con altas capacidades. Próxima edición en septiembre de 2026, con 20 plazas disponibles en La Lobera de Gredos.",
    keywords: "adultos altas capacidades, encuentro altas capacidades, DAC-PAC adultos",
    image: absoluteUrl("/images/encuentro/adultos-encuentro.jpg"),
    schema: [organizationSchema],
  },
  "/cursos-especializados": {
    title: "Extraescolares para altas capacidades | DAC-PAC",
    description:
      "Extraescolares para ninos y jovenes con altas capacidades o alta curiosidad. Grupos reducidos, reto real, continuidad durante el curso escolar y aprendizaje con sentido.",
    keywords: "extraescolares altas capacidades, actividades altas capacidades, DAC-PAC extraescolares",
    image: absoluteUrl("/images/cursos/hero-cursos.jpg"),
    schema: [organizationSchema],
  },
  "/faq": {
    title: "Preguntas frecuentes sobre campamento para altas capacidades | DAC-PAC",
    description:
      "Resuelve dudas sobre el campamento para altas capacidades, el encuentro para adultos, diagnosticos, edades, inscripciones y funcionamiento de DAC-PAC.",
    keywords: "FAQ altas capacidades, preguntas campamento altas capacidades, DAC-PAC preguntas frecuentes",
    image: DEFAULT_IMAGE,
    schema: [organizationSchema],
  },
  "/contacto": {
    title: "Contacto | DAC-PAC",
    description:
      "Contacta con DAC-PAC para resolver dudas sobre campamento, encuentro para adultos, extraescolares e inscripciones para altas capacidades.",
    keywords: "contacto DAC-PAC, informacion campamento altas capacidades",
    image: DEFAULT_IMAGE,
    schema: [
      organizationSchema,
      () => ({
        "@context": "https://schema.org",
        "@type": "ContactPage",
        name: "Contacto DAC-PAC",
        url: absoluteUrl("/contacto"),
      }),
    ],
  },
  "/preinscripcion": {
    title: "Preinscripcion | DAC-PAC",
    description:
      "Accede a la preinscripcion de DAC-PAC y elige la experiencia que mejor encaja: campamento, encuentro para adultos o extraescolares.",
    keywords: "preinscripcion DAC-PAC, inscripcion campamento altas capacidades",
    image: DEFAULT_IMAGE,
    schema: [organizationSchema],
  },
  "/legal": {
    title: "Aviso legal y privacidad | DAC-PAC",
    description: "Informacion legal, privacidad, cookies y tratamiento de datos del sitio web de DAC-PAC.",
    keywords: "aviso legal DAC-PAC, privacidad DAC-PAC",
    image: DEFAULT_IMAGE,
    schema: [organizationSchema],
  },
  "/equipo": {
    title: "Jana Martinez-Piqueras y equipo especializado en altas capacidades | DAC-PAC",
    description:
      "Conoce al equipo de DAC-PAC y a Jana Martinez-Piqueras, especialista en altas capacidades y fundadora del proyecto.",
    keywords:
      "Jana Martinez-Piqueras, equipo DAC-PAC, especialista altas capacidades, Jana campamento altas capacidades",
    image: absoluteUrl("/images/equipo/jana-martinez-piqueras.png"),
    schema: [organizationSchema],
  },
};

const activitySeo = {
  dibujo: {
    title: "Creatividad plastica para ninos y jovenes | DAC-PAC",
    description:
      "Extraescolar de creatividad plastica desde 6 anos. Tecnicas de dibujo, observacion, composicion y expresion visual en grupos reducidos.",
    keywords: [
      "creatividad plastica San Sebastian de los Reyes",
      "clases de dibujo para ninos",
      "extraescolar creatividad plastica Madrid",
      "DAC-PAC creatividad plastica",
    ],
  },
  interpretacion: {
    title: "Interpretacion para ninos y jovenes | Extraescolares DAC-PAC",
    description:
      "Extraescolar de interpretacion para trabajar voz, cuerpo, improvisacion, presencia escenica y expresion en grupo durante el curso escolar.",
    keywords: [
      "interpretacion ninos",
      "teatro jovenes",
      "extraescolar interpretacion",
      "DAC-PAC interpretacion",
    ],
  },
  "programacion-iniciacion": {
    title: "Programacion basica para ninos | DAC-PAC",
    description:
      "Programacion basica desde 6 anos: Git, Python, testing, APIs y bases de datos. Grupos de maximo 8 alumnos y opcion online bajo consulta.",
    keywords: [
      "programacion para ninos San Sebastian de los Reyes",
      "clases programacion ninos Madrid",
      "programacion Python ninos",
      "extraescolar programacion online",
    ],
  },
  "programacion-avanzado": {
    title: "Programacion avanzada para adolescentes | DAC-PAC",
    description:
      "Curso anual de programacion avanzada desde 14 anos: desarrollo real, visita a empresa, hackathon, certificacion cloud y opcion online.",
    keywords: [
      "programacion avanzada adolescentes",
      "curso programacion jovenes Madrid",
      "hackathon adolescentes",
      "certificacion cloud jovenes",
    ],
  },
  "produccion-musical": {
    title: "Produccion musical con Ableton | DAC-PAC",
    description:
      "Curso escolar de produccion musical con Ableton Live desde 14 anos para crear, mezclar y exportar un tema propio.",
    keywords: [
      "produccion musical adolescentes",
      "Ableton Live curso jovenes",
      "extraescolar produccion musical Madrid",
      "curso produccion musical San Sebastian de los Reyes",
    ],
  },
  "matematicas-iniciacion": {
    title: "Pensamiento logico matematico para ninos | DAC-PAC",
    description:
      "Pensamiento logico matematico desde 10 anos: retos imposibles, codigos secretos, estrategias ganadoras, razonamiento y creatividad.",
    keywords: [
      "pensamiento logico matematico ninos",
      "retos matematicos ninos",
      "extraescolar matematicas Madrid",
      "pensamiento logico ninos",
    ],
  },
  "matematicas-avanzado": {
    title: "Pensamiento logico matematico avanzado | DAC-PAC",
    description:
      "Pensamiento logico matematico avanzado para adolescentes y adultos. A partir de 14 anos o cierto nivel; consulta si eres menor.",
    keywords: [
      "pensamiento logico matematico avanzado",
      "matematicas adultos altas capacidades",
      "taller pensamiento matematico",
      "extraescolar matematicas avanzado",
    ],
  },
  ajedrez: {
    title: "Ajedrez para ninos y jovenes | Extraescolares DAC-PAC",
    description:
      "Extraescolar de ajedrez para trabajar estrategia, tactica, calculo, toma de decisiones y analisis de partidas durante el curso escolar.",
    keywords: [
      "ajedrez ninos",
      "extraescolar ajedrez",
      "clases ajedrez jovenes",
      "DAC-PAC ajedrez",
    ],
  },
  "hacking-etico": {
    title: "Hacking etico para jovenes en Madrid | DAC-PAC",
    description:
      "Curso presencial anual de hacking etico desde 14 anos o cierto nivel: laboratorios, CTF, seguridad web, visita a empresa y preparacion eJPT.",
    keywords: [
      "hacking etico jovenes",
      "ciberseguridad para adolescentes",
      "curso hacking etico Madrid",
      "extraescolar ciberseguridad presencial",
    ],
  },
  "filosofia-para-ninos": {
    title: "Filosofia para Ninos | Extraescolares DAC-PAC",
    description:
      "Extraescolar de Filosofia para Ninos para entrenar pensamiento critico, dialogo, escucha, argumentacion y creatividad en grupos reducidos.",
    keywords: [
      "filosofia para ninos",
      "pensamiento critico ninos",
      "extraescolar filosofia",
      "DAC-PAC filosofia para ninos",
    ],
  },
  "debate-y-oratoria": {
    title: "Debate y oratoria para ninos y jovenes | DAC-PAC",
    description:
      "Extraescolar de Debate y oratoria para aprender a hablar en publico, argumentar, escuchar, refutar y comunicar ideas con seguridad.",
    keywords: [
      "debate y oratoria ninos",
      "oratoria jovenes",
      "hablar en publico ninos",
      "extraescolar debate Madrid",
    ],
  },
};

function getActivityPrice(activity) {
  const priceItem = activity.practical?.find((item) => item.label.toLowerCase().includes("precio"));
  const match = priceItem?.value.match(/(\d+)/);

  return match?.[1] || null;
}

function courseSchema(activity) {
  const price = getActivityPrice(activity);

  return {
    "@context": "https://schema.org",
    "@type": "Course",
    name: activity.label,
    description: activity.description,
    provider: {
      "@type": "Organization",
      name: "DAC-PAC",
      sameAs: SITE_URL,
    },
    educationalLevel: activity.level,
    courseMode: activity.practical?.some((item) => /online/i.test(item.value)) ? "Blended" : "Onsite",
    inLanguage: "es-ES",
    url: absoluteUrl(activity.href),
    ...(price
      ? {
          offers: {
            "@type": "Offer",
            price,
            priceCurrency: "EUR",
            availability: "https://schema.org/InStock",
            url: absoluteUrl(activity.href),
          },
        }
      : {}),
  };
}

function breadcrumbSchema(activity) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Extraescolares",
        item: absoluteUrl("/cursos-especializados"),
      },
      {
        "@type": "ListItem",
        position: 2,
        name: activity.label,
        item: absoluteUrl(activity.href),
      },
    ],
  };
}

function buildActivitySeo(activity, canonicalPath = activity.href) {
  const customSeo = activitySeo[activity.slug] || {};

  return {
    title: customSeo.title || `${activity.label} | Extraescolares DAC-PAC`,
    description: customSeo.description || activity.summary,
    keywords: (customSeo.keywords || [
      activity.label,
      "extraescolares altas capacidades",
      "DAC-PAC extraescolares",
    ]).join(", "),
    image: activity.image,
    canonical: absoluteUrl(canonicalPath),
    schema: [organizationSchema, () => courseSchema(activity), () => breadcrumbSchema(activity)],
  };
}

extraescolares.forEach((activity) => {
  pageSeo[activity.href] = buildActivitySeo(activity);
  activity.aliases?.forEach((alias) => {
    pageSeo[`/cursos-especializados/${alias}`] = buildActivitySeo(activity, activity.href);
  });
});

function notFoundSeo(pathname) {
  return {
    title: "404 | Pagina no encontrada | DAC-PAC",
    description:
      "La pagina solicitada no existe o ya no esta disponible en DAC-PAC. Vuelve al inicio o navega a una seccion valida.",
    keywords: "404 DAC-PAC, pagina no encontrada",
    image: DEFAULT_IMAGE,
    canonical: absoluteUrl(pathname || "/404"),
    robots: "noindex,nofollow",
    schema: [organizationSchema],
  };
}

function ensureMeta(name, content, attribute = "name") {
  if (!content) {
    return;
  }

  let tag = document.head.querySelector(`meta[${attribute}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function ensureLink(rel, href) {
  if (!href) {
    return;
  }

  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

function upsertJsonLd(schemaList = []) {
  document.head.querySelectorAll('script[data-seo="dynamic-schema"]').forEach((node) => node.remove());

  schemaList
    .filter(Boolean)
    .map((entry) => (typeof entry === "function" ? entry() : entry))
    .forEach((entry) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seo = "dynamic-schema";
      script.text = JSON.stringify(entry);
      document.head.appendChild(script);
    });
}

export function applySeo(pathname) {
  const seo = pageSeo[pathname] || notFoundSeo(pathname);
  const canonical = seo.canonical || absoluteUrl(pathname);
  const image = seo.image || DEFAULT_IMAGE;

  document.documentElement.lang = "es";
  document.title = seo.title;

  ensureMeta("description", seo.description);
  ensureMeta("keywords", seo.keywords);
  ensureMeta("robots", seo.robots || "index,follow,max-image-preview:large");
  ensureMeta("og:type", "website", "property");
  ensureMeta("og:locale", "es_ES", "property");
  ensureMeta("og:site_name", SITE_NAME, "property");
  ensureMeta("og:title", seo.title, "property");
  ensureMeta("og:description", seo.description, "property");
  ensureMeta("og:url", canonical, "property");
  ensureMeta("og:image", image, "property");
  ensureMeta("twitter:card", "summary_large_image");
  ensureMeta("twitter:title", seo.title);
  ensureMeta("twitter:description", seo.description);
  ensureMeta("twitter:image", image);
  ensureLink("canonical", canonical);
  upsertJsonLd(seo.schema);
}

export { SITE_URL };
